// Queries the change log entries of a user's vehicles

import { VehicleChangeLogEntry, VehicleQueryParams } from "../types/vehicle";
import { createDataContext } from "./Context";

const parseVehicleChangelogResponse = (response: VehicleChangeLogEntry[]): VehicleChangeLogEntry[] => {
    return Array.isArray(response)
        ? response.filter((entry) => entry !== null && typeof entry === 'object')
        : [];
}

export const { useDataContext: useVehicleChangelogContext, DataProvider: VehicleChangelogProvider } = createDataContext<VehicleChangeLogEntry, VehicleQueryParams>(
    'tripQueryAPI',
    '/users/v1/getvehiclechangelog',
    parseVehicleChangelogResponse
)
